import { render, staticRenderFns } from "./CouponsRedeem.vue?vue&type=template&id=4e2dbb52"
import script from "./CouponsRedeem.vue?vue&type=script&lang=js"
export * from "./CouponsRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports